module.exports = __webpack_public_path__ + "static/story-radio-v2.ed0825d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/story-radio-v2.png
// module id = 479
// module chunks = 261706647590803